import {
  nextTick,
  onMounted,
  onUnmounted,
  watch,
} from '@vue/composition-api';

const getValue = value => (value && value.value !== undefined ? value.value : value);

const getFullscreenElement = () => (
  document.fullscreenElement
  || document.webkitFullscreenElement
  || document.mozFullScreenElement
  || document.msFullscreenElement
);

export function useFullscreenModalTransport(modalId, isVisible) {
  const moveModal = () => {
    const id = getValue(modalId);
    if (!id || typeof document === 'undefined') return;

    const modal = document.getElementById(id);
    const modalOuter = modal?.parentElement;
    if (!modalOuter) return;

    const target = getFullscreenElement() || document.body;
    if (modalOuter.parentElement !== target) {
      target.appendChild(modalOuter);
    }
  };

  const scheduleMove = () => {
    nextTick(() => {
      requestAnimationFrame(moveModal);
      setTimeout(moveModal, 50);
    });
  };

  const onFullscreenChange = () => {
    scheduleMove();
  };

  onMounted(() => {
    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);
    document.addEventListener('mozfullscreenchange', onFullscreenChange);
    document.addEventListener('MSFullscreenChange', onFullscreenChange);
  });

  onUnmounted(() => {
    document.removeEventListener('fullscreenchange', onFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
    document.removeEventListener('mozfullscreenchange', onFullscreenChange);
    document.removeEventListener('MSFullscreenChange', onFullscreenChange);
    moveModal();
  });

  watch(isVisible, visible => {
    if (visible) scheduleMove();
  });

  return {
    scheduleMove,
  };
}
